import { baseApi } from "api/BaseApi";

import {
  PclCounts,
  PclProductCheckResponse,
  PclProductDetail,
  PublicPclProduct,
} from "./product.types";

const PCL_BASE_URL = "/project/product";

export const publicProductApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    pclProductCheck: build.query<boolean, string | number>({
      query: (product_id) => ({
        url: `${PCL_BASE_URL}/is_pcl_product/`,
        params: { product_id },
      }),
      transformResponse: (response: PclProductCheckResponse) =>
        response.is_pcl_product,
    }),

    pclProduct: build.query<PclProductDetail, string | number>({
      query: (productId) => `${PCL_BASE_URL}/pcl_products/${productId}/`,
    }),

    getAllPclProducts: build.query<PublicPclProduct[], void>({
      query: () => ({
        url: `${PCL_BASE_URL}/pcl_products_all/`,
      }),
    }),

    loadProductPclCounts: build.query<PclCounts, void>({
      query: () => `${PCL_BASE_URL}/get_pcl_counts/`,
      transformResponse: (response: Omit<PclCounts, "total">) => {
        if (!response)
          return {
            certified: 0,
            in_evaluation: 0,
            archived: 0,
            total: 0,
          };

        const total =
          response.certified + response.in_evaluation + response.archived;
        return { ...response, total };
      },
    }),
  }),

  overrideExisting: false,
});

export const {
  usePclProductCheckQuery,
  usePclProductQuery,
  useGetAllPclProductsQuery,
  useLoadProductPclCountsQuery,
} = publicProductApi;
